import { Box, Container, Heading, Stack, Text } from '@chakra-ui/react';
import { useLingui } from '@lingui/react/macro';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

import { useIsAuth } from '#modules/user/features/auth/hooks/useIsAuth';
import { useOAuthFailureToast } from '#modules/user/features/auth/hooks/useOAuthFailureToast';
import { GuildsList } from '#features/discord-lfg-admin/components/GuildsList';
import { SignInWithDiscord } from '#features/discord-lfg-admin/components/SignInWithDiscord';
import {
  eyebrowProps,
  landingContrastCss,
  pageHeadingProps,
} from '#features/discord-lfg-admin/styles';

export const Route = createFileRoute('/{-$locale}/_layout/discord-lfg-bot/admin/')({
  ssr: false,
  component: DiscordLfgAdminListPage,
  // Private admin dashboard — keep it out of search indexes.
  head: () => ({ meta: [{ name: 'robots', content: 'noindex, nofollow' }] }),
});

function DiscordLfgAdminListPage() {
  const { t } = useLingui();
  const isAuth = useIsAuth();
  // Кнопка входа здесь своя, мимо useOAuth, поэтому и отказ приезжал сюда молча: бэк возвращает
  // человека на ?msg=<причина>, а страница показывала ту же кнопку, будто ничего не случилось.
  useOAuthFailureToast();
  const [needScopeUpgrade, setNeedScopeUpgrade] = useState(false);

  if (!isAuth) {
    return (
      <Box css={landingContrastCss}>
        <SignInWithDiscord variant="signIn" />
      </Box>
    );
  }

  if (needScopeUpgrade) {
    return (
      <Box css={landingContrastCss}>
        <SignInWithDiscord variant="connectScopes" />
      </Box>
    );
  }

  return (
    <Container maxW="6xl" py={8} css={landingContrastCss}>
      <Stack gap={8}>
        <Box>
          <Text {...eyebrowProps} mb={2}>
            {t`Admin dashboard`}
          </Text>
          <Heading size="xl" fontSize={{ base: '3xl', md: '4xl' }} {...pageHeadingProps}>
            {t`Your Discord servers`}
          </Heading>
        </Box>
        <GuildsList onScopeError={() => setNeedScopeUpgrade(true)} />
      </Stack>
    </Container>
  );
}
